import { IconButton, Popover, Text, Tooltip } from "@aurem/ui";
import { ChevronUp, Sparkles } from "lucide-react";
import type { FC } from "react";
import { useState } from "react";
import { useTranslations } from "../i18n";

interface MenuItem {
  id: string;
  label: string;
  shortcut: string;
  onClick: () => void;
}

interface IntelligenceHubMenuProps {
  menuItems: MenuItem[];
}

export const IntelligenceHubMenu: FC<IntelligenceHubMenuProps> = ({
  menuItems,
}) => {
  const { t } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  const handleItemClick = (onClick: () => void) => {
    onClick();
    setIsOpen(false);
  };

  const isMac = /Mac/i.test(navigator.userAgent);
  const modifier = isMac ? <ChevronUp size={11} strokeWidth={2.5} /> : "CTRL";

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      content={
        <div className="w-44 gap-1 flex flex-col">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleItemClick(item.onClick)}
              className="flex w-full items-center justify-between px-3 py-2 hover:bg-neutral-500/5  focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-500"
            >
              <Text size="sm">{item.label}</Text>
              <div className="flex items-center gap-1">
                <div className="flex items-center justify-center px-1.5 h-6 text-[11px] font-medium text-neutral-500/20 border border-neutral-500/20 rounded-[6px]">
                  {modifier}
                </div>
                <kbd className="flex items-center justify-center px-2 h-6 text-[11px] font-medium text-neutral-500/20 border border-neutral-500/20 rounded-[6px]">
                  {item.shortcut}
                </kbd>
              </div>
            </button>
          ))}
        </div>
      }
      placement="bottom-end"
      offset={8}
      contentClassName="px-0"
    >
      <IconButton variant="ghost" color="neutral">
        <Tooltip content={t("apps.admin.common.aiAssistant")}>
          <Sparkles className="rtl:-scale-x-100" size={24} />
        </Tooltip>
      </IconButton>
    </Popover>
  );
};
